import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppStateService } from '@core/services/app-state.service'; 
import { environment } from '@environment/environment';
import { Authentication } from '@hsi/ui-core';
import { SettingsComponent } from '../settings/settings.component';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {

  constructor(
    private dialog:MatDialog, 
    public appStateService:AppStateService,
    public authenticationService:Authentication.Core.AuthenticationService) { }

  videoPlayerUrl = environment.videoPlayer;
  ngOnInit(): void {
  } 
  settingsDialog(){
    let dialogRef = this.dialog.open(SettingsComponent, { width: '400px' });  
  } 
}
